var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.hasLogin)?_c('div',{attrs:{"id":"nav"}},[_c('h1',[_vm._v("ClearPoint Skills Matrix")]),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/update"}},[_vm._v("Manage skills")])],1)]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }